export default {
	state: {
		videos: [
			{
				id: '01',
				vurl: '/img/video1.mp4',
				name: 'Видео  ',
				spanName: '(мельница)',
				picUrl: '/img/forVideo2.jpg'
			},
			{
				id: '02',
				vurl: '/img/video2.mp4',
				name: 'Хлеб Гриднев',
				spanName: '(хранение)',
				picUrl: '/img/forVideo3.png'
			}
		]
	},
	mutations: {},
	actions: {},


	getters: {
		getVideos (state) {
			return state.videos
		}
	}
}